import { formattedDate } from './currentDate';
import { formattedDayTime } from './currentTimeDay';

export const Utils = {
  formattedDayTime,
  formattedDate,
};
